import { Avatar, Box, Typography } from '@mui/material';
import { getFullName } from 'utils/helpers';

interface ProfileTypes {
    user: any;
    my?: number;
    width?: number | string;
    email?: string;
}

const Profile: React.FC<ProfileTypes> = ({ user, my, width = 370 }) => (
    <Box
        sx={{
            display: 'flex',
            flexDirection: 'row',
            backgroundColor: '#F9FAFB',
            width: width,
            justifyContent: 'flex-start',
            alignItems: 'center',
            p: 4,
            my: my,
            borderRadius: 2,
        }}
    >
        <div>
            <Avatar src={user?.logoUrl} sx={{ width: 74, height: 74 }} />
        </div>
        <div style={{ marginLeft: 16 }}>
            <Typography sx={{ fontSize: 16, color: '#1F2937', fontWeight: 400 }} variant="h2">
                {getFullName(user) || user?.name}
            </Typography>
            <Typography sx={{ fontSize: 14, color: '#6B7280', my: 0.2 }} variant="body2">
                {user?.email || user?.username || ''}
            </Typography>
        </div>
    </Box>
);

export default Profile;
